type TraceSession = { traceId: string; requestId: string };

let session: TraceSession | null = null;

export function initTraceContext(): TraceSession {
  const traceId = crypto.randomUUID().replace(/-/g, '').slice(0, 32);
  const requestId = `sess-${Date.now().toString(36)}`;
  session = { traceId, requestId };
  return session;
}

export function getTraceContext(): TraceSession {
  if (!session) return initTraceContext();
  return session;
}

export function newSpanId(action: string): string {
  return `${action}-${Date.now().toString(36)}`;
}
